function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  x: 77.858,
  y: 36.848,
  width: 39.834,
  height: 40.945,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "b"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "b"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "c",
  x: 103.175,
  y: 36.848,
  width: 39.835,
  height: 40.945,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "d"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "d"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "e",
  x: 129.528,
  y: 29.697,
  width: 38.978,
  height: 48.873,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "f"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "f"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "g",
  x: 154.42,
  y: 29.445,
  width: 24.259,
  height: 24.076,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "h"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "h"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "i",
  x: 154.939,
  y: 37.662,
  width: 23.308,
  height: 41.161,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "j"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "j"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "k",
  x: 163.501,
  y: 30.51,
  width: 30.361,
  height: 48.313,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "l"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "l"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "m",
  x: 176.872,
  y: 36.849,
  width: 36.644,
  height: 41.973,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "n"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "n"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "o",
  x: 0,
  y: 0,
  width: 90.943,
  height: 90.864,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "p"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "p"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(9 6)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -9, -6)",
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M249.9,150.638a10.582,10.582,0,0,0-3.806-4.217,11.2,11.2,0,0,0-11.4-.144,10.426,10.426,0,0,0-3.916,4.129,12.339,12.339,0,0,0-1.4,5.87,12.52,12.52,0,0,0,1.313,5.658,10.417,10.417,0,0,0,3.828,4.223,11.473,11.473,0,0,0,11.579.016,10.339,10.339,0,0,0,3.808-4.206,12.617,12.617,0,0,0,1.306-5.691A12.415,12.415,0,0,0,249.9,150.638Zm-4.036,5.618a10.63,10.63,0,0,1-.681,3.615,5.3,5.3,0,0,1-1.852,2.444,5.179,5.179,0,0,1-3.1.893,4.48,4.48,0,0,1-4.1-2.024,8.948,8.948,0,0,1-1.4-4.907,9.5,9.5,0,0,1,.676-3.666,5.358,5.358,0,0,1,1.9-2.431,5.082,5.082,0,0,1,3.008-.864,4.862,4.862,0,0,1,3,.9,5.576,5.576,0,0,1,1.888,2.48A9.411,9.411,0,0,1,245.864,156.256Z",
  transform: "translate(-142.52 -101.94)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -9, -6)",
  filter: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M263.762,150.638a10.586,10.586,0,0,0-3.808-4.217,10.773,10.773,0,0,0-5.771-1.633,10.884,10.884,0,0,0-5.633,1.488,10.42,10.42,0,0,0-3.914,4.129,12.338,12.338,0,0,0-1.4,5.87,12.518,12.518,0,0,0,1.311,5.658,10.429,10.429,0,0,0,3.828,4.223,11.473,11.473,0,0,0,11.579.016,10.339,10.339,0,0,0,3.808-4.206,12.619,12.619,0,0,0,1.308-5.691A12.415,12.415,0,0,0,263.762,150.638Zm-4.036,5.618a10.674,10.674,0,0,1-.683,3.615,5.287,5.287,0,0,1-1.852,2.444,5.175,5.175,0,0,1-3.1.893,4.48,4.48,0,0,1-4.1-2.024,8.962,8.962,0,0,1-1.4-4.907,9.5,9.5,0,0,1,.674-3.666,5.358,5.358,0,0,1,1.9-2.431,5.086,5.086,0,0,1,3.008-.864,4.868,4.868,0,0,1,3,.9,5.6,5.6,0,0,1,1.888,2.48A9.413,9.413,0,0,1,259.726,156.256Z",
  transform: "translate(-131.07 -101.94)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -9, -6)",
  filter: "url(#e)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M278.085,159.48a7.491,7.491,0,0,0-2.226-3.12,7.986,7.986,0,0,0-2.572-1.465,5.683,5.683,0,0,0,1-.884,7.3,7.3,0,0,0,1.527-2.645,9.287,9.287,0,0,0,.449-2.842,7.319,7.319,0,0,0-1.284-3.863,8.371,8.371,0,0,0-3.214-2.78,9.821,9.821,0,0,0-4.453-1.01h-6.922a2.772,2.772,0,0,0-1.907.681,2.565,2.565,0,0,0-.809,2.02v25.462a2.529,2.529,0,0,0,2.844,2.71h7.618a11.552,11.552,0,0,0,5.585-1.3A9.368,9.368,0,0,0,277.388,167a8.661,8.661,0,0,0,1.26-4.466A9.284,9.284,0,0,0,278.085,159.48Zm-7.664-8.208a3.559,3.559,0,0,1-1.439,1.421,4.754,4.754,0,0,1-2.362.553h-3.646v-7.705h4.078a3.588,3.588,0,0,1,2.823,1.107,4.044,4.044,0,0,1,.544,4.624ZM273.3,162.43a4.763,4.763,0,0,1-.677,2.354,4.344,4.344,0,0,1-1.925,1.646,7.886,7.886,0,0,1-3.384.648h-4.336v-9.324H267.7a6.692,6.692,0,0,1,3.149.674,4.379,4.379,0,0,1,1.836,1.717A4.546,4.546,0,0,1,273.3,162.43Z",
  transform: "translate(-119.14 -105.18)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(154.42 29.445)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -163.42, -35.45)",
  filter: "url(#g)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M274.45,146.811a3.027,3.027,0,0,0,2.179-.9,2.933,2.933,0,0,0,0-4.281,3.147,3.147,0,0,0-4.4.013,2.9,2.9,0,0,0,.011,4.265A3.073,3.073,0,0,0,274.45,146.811Z",
  transform: "translate(-107.88 -105.29)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -163.42, -35.45)",
  filter: "url(#i)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M276.065,145.9a2.765,2.765,0,0,0-1.85-.661,2.644,2.644,0,0,0-1.837.7,2.514,2.514,0,0,0-.794,1.94V165.83a2.43,2.43,0,0,0,.82,1.89,2.682,2.682,0,0,0,1.812.674,2.779,2.779,0,0,0,1.843-.658,2.413,2.413,0,0,0,.833-1.907V147.8A2.412,2.412,0,0,0,276.065,145.9Z",
  transform: "translate(-107.64 -101.57)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -9, -6)",
  filter: "url(#k)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M287.945,148.569a2.569,2.569,0,0,0-1.861-.661h-.908v-4.038a2.353,2.353,0,0,0-.849-1.936,2.926,2.926,0,0,0-1.872-.615,2.764,2.764,0,0,0-1.808.619,2.292,2.292,0,0,0-.82,1.841v4.129h-.908a2.414,2.414,0,0,0-2.637,2.3l-.011.091.013.09a2.463,2.463,0,0,0,.82,1.552,2.619,2.619,0,0,0,1.815.636h.908V169a2.47,2.47,0,0,0,2.544,2.632,3,3,0,0,0,1.921-.647,2.356,2.356,0,0,0,.884-1.9v-16.5h1.087a2.321,2.321,0,0,0,1.7-.683,2.251,2.251,0,0,0,.665-1.605A2.333,2.333,0,0,0,287.945,148.569Z",
  transform: "translate(-103.77 -104.81)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -9, -6)",
  filter: "url(#m)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M300.932,157.831a9.624,9.624,0,0,0-3.965-2.522c-.415-.183-1.118-.433-2.15-.767-.975-.316-1.815-.626-2.5-.92a6.271,6.271,0,0,1-1.671-1.047,2.234,2.234,0,0,1-.736-1.183,1.856,1.856,0,0,1,.8-1.3,4.3,4.3,0,0,1,2.583-.636,3.73,3.73,0,0,1,1.361.267c.42.192,1.094.539,2,1.035a10.5,10.5,0,0,0,2.325,1.016l.124.031.126-.011a2.694,2.694,0,0,0,1.662-.742,2.224,2.224,0,0,0,.736-1.633,3.224,3.224,0,0,0-1.171-2.263,9.291,9.291,0,0,0-3.178-1.651,13.471,13.471,0,0,0-4.376-.718H292.9a10.8,10.8,0,0,0-4.226.983,7.363,7.363,0,0,0-2.962,2.453,5.958,5.958,0,0,0-1.076,3.426,5.066,5.066,0,0,0,1.2,3.424,8.066,8.066,0,0,0,2.57,2c.891.435,2.163.964,3.779,1.576a22.359,22.359,0,0,1,3.238,1.426c1.361.747,1.361,1.529,1.361,1.784a1.629,1.629,0,0,1-1.006,1.593,6.429,6.429,0,0,1-2.884.641,6.889,6.889,0,0,1-2.878-.73l-.073-.035a6.838,6.838,0,0,1-1.028-.632,14.65,14.65,0,0,0-1.443-.9,2.674,2.674,0,0,0-3.191.327,2.331,2.331,0,0,0-.694,1.671l.007.1a3.06,3.06,0,0,0,1.326,2.263,12.381,12.381,0,0,0,8.009,2.6h.013a12.055,12.055,0,0,0,5-1.019,7.537,7.537,0,0,0,3.163-2.626,6.754,6.754,0,0,0,1.125-3.547A5.608,5.608,0,0,0,300.932,157.831Z",
  transform: "translate(-97.72 -101.94)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -9, -6)",
  filter: "url(#o)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M222.73,197.477c-6.639,0-13.176-.024-19.424-.071a16.529,16.529,0,0,1-11.534-4.836,16.272,16.272,0,0,1-4.92-11.455c-.135-12.956-.137-26.474-.006-40.172a16.281,16.281,0,0,1,4.816-11.322,16.1,16.1,0,0,1,11.263-4.891c6.107-.079,12.374-.117,19.152-.117,6.528,0,13.473.035,21.23.108a16.128,16.128,0,0,1,9.919,3.627,17.227,17.227,0,0,1,5.808,8.913,3.593,3.593,0,0,1-1,3.949c-2.758,2.758-5.5,5.616-8.148,8.392-1.806,1.887-3.671,3.837-5.527,5.731a12.005,12.005,0,0,0-2.981,4.024,54.344,54.344,0,0,0-1.337,8.034l-7.517-10.177,9.068-10.14a4.68,4.68,0,0,0-.369-6.608l-.82-.734a4.678,4.678,0,0,0-6.606.369L215.73,160.31V143.182a4.679,4.679,0,0,0-4.679-4.679h-3.51a4.679,4.679,0,0,0-4.679,4.679v37.07a4.679,4.679,0,0,0,4.679,4.679h3.51a4.721,4.721,0,0,0,4.5-4.9l.179-4.383a4.686,4.686,0,0,0,1.156-.935l8.515-9.525,11.479,15.534a4.7,4.7,0,0,0,3.768,1.9,4.618,4.618,0,0,0,2.776-.915l.889-.656a4.68,4.68,0,0,0,.983-6.544l-1.149-1.118c.11.029.29-.179.406-.179.152,0,.183-.312.329-.36.91-.274,1.852-.535,2.762-.787a57.462,57.462,0,0,0,6.217-1.982,13.149,13.149,0,0,0,4.687-3.748c.254-.27.517-.552.793-.842-.005,2.029.082,4.066.17,6.034a56.519,56.519,0,0,1-.349,12.31,16.347,16.347,0,0,1-5.6,9.687,16.543,16.543,0,0,1-10.5,3.885C236.054,197.453,229.214,197.477,222.73,197.477Z",
  transform: "translate(-177.75 -118.61)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  d: "M236.646,127.942c3.79-.09,8.422,3.927,8.853,7.516a4.211,4.211,0,0,1-1.07,2.878c-.97,1.428-2.758,2.188-3.158,4.117-.144.694-.747.3-1.1-.11a82.991,82.991,0,0,0-9.373-9.143c-.42-.351-.78-.964-.181-1.184,2.069-.756,3.149-2.782,5.039-3.722A7.147,7.147,0,0,1,236.646,127.942Z",
  transform: "translate(-150.763 -121.863)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M204.562,173.156c.042,1.538-.561,3.377-2.139,3.129.079-.813.223-2.741.225-3.554q.019-18.262.02-36.521a9.293,9.293,0,0,0-.405-2.971c2.088-.415,2.246-.289,2.285,1.872C204.548,140.394,204.562,171.085,204.562,173.156Z",
  transform: "translate(-173.93 -117.641)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M221.66,149.025c-3.834,3.835-7.2,8.087-10.854,12.083-1.374,1.558-2.778,3.087-4.108,4.679-.986,1.182-2.544,2.022-3.563.791.6-.557,1.872-1.768,2.409-2.376q12.093-13.687,24.169-27.38a9.346,9.346,0,0,0,1.662-2.495c1.839,1.07,1.87,1.269.479,2.911C228.485,141.2,224.845,144.916,221.66,149.025Z",
  transform: "translate(-173.209 -116.585)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M216.067,148.889a8.023,8.023,0,0,1,4.427,4.151s-3.627,1.9-4.361,1.414S214.6,150.4,216.067,148.889Z",
  transform: "translate(-163.201 -104.551)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M215.876,144.316,214.5,156.562s-.219,5.03,5,3.835,10.995-3.1,10.995-3.1,2.193-2.847,1-2.424-12.763,3.667-12.763,3.667l-1.9-3,1.536-12.5A2.467,2.467,0,0,0,215.876,144.316Z",
  transform: "translate(-163.819 -109.405)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 13.444,
  height: 28.87,
  rx: 2,
  transform: "translate(78.448 12.415) rotate(43.657)",
  fill: "#fff"
}));

var SvgKoobitsLogo = function SvgKoobitsLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213.516,
    height: 90.864,
    viewBox: "0 0 213.516 90.864",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKoobitsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Koobits Logo.0b2b7bba.svg";
export { ForwardRef as ReactComponent };